import React from 'react';
import Skeleton from "react-loading-skeleton";
function FoodCourtTitleSkeleton(){
    return(
        <Skeleton count={1} style={{marginBottom: "28px", lineHeight: 1.2}} height={38} width={500}/>
    );
}
export default FoodCourtTitleSkeleton;